import View                from '@widesk-ui/components/View';
import Tooltip             from '@widesk-ui/components/Tooltip';
import { observer }        from 'mobx-react-lite';
import { SettingOutlined } from '@ant-design/icons';
import leftSidebarStore    from '@/TokamapEditor/stores/leftSidebarStore';
import useDesignTokens     from '@/hooks/useDesignTokens';

/**
 * Segment "Réglages" de la barre flottante (voir `MapFloatingControls`) : les réglages portent sur
 * la carte ouverte (`SettingsSidebar` lit `currentEditorStore`), ils vivent donc sur le plan et non
 * dans la barre du haut, réservée au projet. Rendu à plat, comme `UndoRedo` : c'est la barre qui
 * porte le relief.
 */
const SettingsButton = observer(() => {
	const tokens = useDesignTokens();

	const opened = leftSidebarStore.options.reference === 'settings';

	return (
		<View row centerV px={4}>
			<Tooltip title="Réglages de la carte" placement="bottom">
				<div>
					<View
						h={30}
						w={30}
						br={8}
						center
						pointer
						color={opened ? tokens.color.primary : tokens.text.secondary}
						bg={opened ? tokens.fill.subtle : undefined}
						hover={{ bg: tokens.surface.subtle, color: opened ? tokens.color.primary : tokens.text.default }}
						// Même bascule que l'ancienne entrée de la barre de gauche : un second clic referme.
						onClick={() => opened ? leftSidebarStore.close() : leftSidebarStore.openSettings()}
					>
						<SettingOutlined style={{ fontSize: 17 }} />
					</View>
				</div>
			</Tooltip>
		</View>
	);
});

export default SettingsButton;
